import React from "react";
import { useTranslation } from "locales";
import "./style.scss";

interface Props {
  visible: boolean;
  unreadCount?: number;
  hasMention?: boolean;
  onClick: () => void;
  onMentionClick?: () => void;
}

function ScrollToBottomButton({ visible, unreadCount, hasMention, onClick, onMentionClick }: Props) {
  const { t } = useTranslation();
  const cls = ["scroll-to-bottom-btn"];
  if (!visible) cls.push("__hidden");

  return (
    <div className="scroll-to-bottom-wrap">
      {hasMention && onMentionClick && (
        <button className="scroll-to-mention-btn" onClick={onMentionClick} type="button" title={t("Go to mention")}>
          <span className="scroll-to-mention-btn__icon">@</span>
        </button>
      )}
      <button className={cls.join(" ")} onClick={onClick} type="button">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        </svg>
        {unreadCount && unreadCount > 0 ? (
          <span className="scroll-to-bottom-btn__badge">{unreadCount > 99 ? "99+" : unreadCount}</span>
        ) : null}
      </button>
    </div>
  );
}

export default ScrollToBottomButton;
